export function isEmpty(value) {
  return (
    value === null ||
    value === undefined ||
    value === false ||
    String(value).trim() === ''
  );
}

export function fieldIsRequired(fieldConfig, values) {
  if (!fieldConfig) return false;
  if (fieldConfig.required) return true;
  if (!fieldConfig.required_if) return false;
  return values[fieldConfig.required_if.field] === fieldConfig.required_if.value;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateField(fieldId, fieldConfig, value, values) {
  if (fieldIsRequired(fieldConfig, values) && isEmpty(value)) {
    return 'This field is required.';
  }
  if (
    fieldConfig &&
    fieldConfig.type === 'email' &&
    !isEmpty(value) &&
    !EMAIL_PATTERN.test(String(value).trim())
  ) {
    return 'Enter a valid email address.';
  }
  if (fieldConfig && fieldConfig.max_length && !isEmpty(value) && String(value).length > fieldConfig.max_length) {
    return `Please use ${fieldConfig.max_length} characters or fewer.`;
  }
  return null;
}

export function stepIsComplete(step, fields, values, filesState, extraValidateField) {
  return (step.fields || []).every((fieldId) => {
    const fieldConfig = fields[fieldId] || {};
    const validator = extraValidateField || validateField;
    return !validator(fieldId, fieldConfig, values[fieldId], values, filesState);
  });
}

export function incompleteSteps(steps, fields, values, filesState, extraValidateField) {
  return (steps || []).filter(
    (step) => !stepIsComplete(step, fields, values, filesState, extraValidateField),
  );
}
